import { get, post, put, del } from './index';

// const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

export const getLiftoffMapping = async (entityType) => {
  return await get(`/liftoff_mapping/${entityType}`);
};

export const createLiftoffMapping = async (entityType, obj) => {
  return await post(`/liftoff_mapping/${entityType}`, { entity: obj });
};

export const updateLiftoffMapping = async (entityType, id, obj) => {
  return await put(`/liftoff_mapping/${entityType}`, {
    id,
    entity: obj
  });
};

export const deleteLiftoffMapping = async (entityType, id) => {
  return await del(`/liftoff_mapping/${entityType}`, {
    id
  });
};
